export enum SearchRole {
  System,
  User,
  Agent
}
